import React, { PureComponent } from 'react';
import { parsePrice } from '../../../../../../lib/helper.js';

class OrderHistoryBody extends PureComponent {
  render() {
    const { taxes, header } = this.props;
    return (
      <ul className="list-style">
        <li>
          <u>{header}</u>
        </li>
        {taxes.map((taxData, index) => {
          return (
            <li key={index}>
              {taxData.formattedTitle}
              <span className="pull-right">
                {parsePrice(taxData.calculatedTaxAmount)}
              </span>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default OrderHistoryBody;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/ReceiptDetails/Taxes.jsx